export default {
  cognito: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_0g5LXfSco",
    CLIENT_ID: "6cknme6i1jro3bqnu7btikce7q",
  },
  baseUrl: "https://api.confidentportal.com",
};
